

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PlaceHolderGrid extends Vue {
	@Prop({ default: true })
	private placehold!: boolean;

	@Prop({ default: 'light' })
	private theme!: string;

	@Prop({ default: 3 })
	private rowCount!: number;

	@Prop({ default: 4 })
	private colCount!: number;

	get rowArray(): Array<number> {
		return new Array(this.rowCount);
	}

	get colArray(): Array<number> {
		return new Array(this.colCount);
	}

	get blockSize(): string {
		const width = Math.floor(12 / this.colCount);
		return `col-${width}-md`;
	}
}
